import { render, staticRenderFns } from "./FlagUSA.vue?vue&type=template&id=c2c9d8dc&"
import script from "./FlagUSA.vue?vue&type=script&lang=js&"
export * from "./FlagUSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports